import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36dcd7d9")

_pushScopeId("data-v-36dcd7d9")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  class: "flex-center preview-images",
  style: {"padding":"20px"}
}
const _hoisted_3 = {
  class: "container",
  style: {"padding":"20px"}
}
const _hoisted_4 = { class: "flex margin-bottom-10 margin-top-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上一张 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-1 flex-center" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex-1 flex-center" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下一张 ")
const _hoisted_9 = { style: {"width":"40vw","height":"80vh"} }
const _hoisted_10 = { class: "flex flex-wrap w-full" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", null, "查看所有卡片", -1)
const _hoisted_13 = {
  ref: "preview",
  class: "preview"
}
const _hoisted_14 = { class: "pages-container" }
const _hoisted_15 = { class: "list" }
const _hoisted_16 = {
  key: 0,
  class: "selected"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card_steps = _resolveComponent("card-steps")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_slider = _resolveComponent("el-slider")
  const _component_croped_card_list = _resolveComponent("croped-card-list")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_drawer = _resolveComponent("el-drawer")
  const _component_card_tag_editor = _resolveComponent("card-tag-editor")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withId(() => [
        _createVNode(_component_card_steps, {
          "keyword-id": _ctx.$route.params.id,
          status: {
      preSelect: _ctx.pageStatus.filter(p => p.status === 'PRE_SELECTED_DONE').length === _ctx.pageStatus.length ? 'success' : 'progress',
      crop: 'success'
    },
          simple: "",
          width: "100%"
        }, null, 8, ["keyword-id", "status"])
      ]),
      _: 1
    }),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _withDirectives(_createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.matrix, (i, row) => {
              return (_openBlock(), _createBlock("div", {
                key: i,
                class: "flex"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.matrix, (j, col) => {
                  return (_openBlock(), _createBlock("div", {
                    key: j,
                    ref: `preview-${row*_ctx.matrix + col}`,
                    class: "preview-small"
                  }, [
                    _withDirectives(_createVNode("img", {
                      ref: `img-${row*_ctx.matrix + col}`,
                      src: _ctx.image?.pexelsImageInfo?.photoModalImageGridItemSrc,
                      alt: "The image to preview",
                      class: "small-image",
                      onClick: ($event: any) => (_ctx.cropImage(row*_ctx.matrix + col))
                    }, null, 8, ["src", "onClick"]), [
                      [_vShow, false]
                    ])
                  ], 512))
                }), 128))
              ]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.image]
        ]),
        _withDirectives(_createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              disabled: _ctx.lastImageIndex < 0,
              icon: "el-icon-arrow-left",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectImage(_ctx.lastImageIndex)))
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"]),
            _hoisted_6,
            _createVNode(_component_el_slider, {
              modelValue: _ctx.matrix,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.matrix = $event)),
              max: 5,
              min: 1,
              "show-stops": "",
              style: {"width":"200px"}
            }, null, 8, ["modelValue"]),
            _hoisted_7,
            _createVNode(_component_el_button, {
              disabled: _ctx.nextImageIndex >= _ctx.preSelectedImages.length,
              icon: "el-icon-arrow-right",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectImage(_ctx.nextImageIndex)))
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("img", {
              ref: "image",
              src: _ctx.image?.pexelsImageInfo?.photoModalImageGridItemSrc,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_croped_card_list, {
                cards: _ctx.cards,
                "fix-height": _ctx.fixHeight,
                "fix-width": _ctx.fixWidth,
                image: _ctx.image,
                onClickCard: _ctx.onCardClick,
                onCardRemoved: _ctx.cardRemoved
              }, null, 8, ["cards", "fix-height", "fix-width", "image", "onClickCard", "onCardRemoved"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.image]
        ]),
        _createVNode("div", _hoisted_11, [
          (!_ctx.image)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "点击右侧分页按钮选择图片"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_affix, { offset: 70 }, {
          default: _withId(() => [
            _createVNode(_component_el_scrollbar, { class: "full-height" }, {
              default: _withId(() => [
                _createVNode(_component_router_link, {
                  to: {name: 'KeywordCardList', params: { id: _ctx.id} }
                }, {
                  default: _withId(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["to"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageStatus.filter(p => p.selectedCount > 0), (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.pageNum,
                    class: "margin-10 margin-right-30",
                    onClick: ($event: any) => (_ctx.changePage(item.pageNum))
                  }, [
                    _createVNode(_component_el_badge, {
                      type: _ctx.currPageNum === item.pageNum ? 'primary' : item.cropedCount === item.selectedCount ? 'success' : 'info',
                      value: `${item.cropedCount}/${item.selectedCount}`
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: _ctx.currPageNum === item.pageNum ? 'primary' : item.cropedCount === item.selectedCount ? 'success' : 'info',
                          round: "",
                          size: "small"
                        }, {
                          default: _withId(() => [
                            _createTextVNode("第" + _toDisplayString(item.pageNum) + "页 ", 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["type", "value"])
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_13, null, 512)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.imagePickerVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.imagePickerVisible = $event)),
      direction: "rtl",
      title: "选图"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.preSelectedImages, (image, index) => {
              return (_openBlock(), _createBlock("div", {
                key: image.pexelsImageInfo.photoModalMediumId,
                class: "list-item"
              }, [
                _createVNode(_component_el_image, {
                  src: image.pexelsImageInfo.photoModalImageGridItemSrc,
                  onClick: ($event: any) => (_ctx.selectImage(index))
                }, null, 8, ["src", "onClick"]),
                (image.croped)
                  ? (_openBlock(), _createBlock("div", _hoisted_16, [
                      _createVNode(_component_el_button, {
                        circle: "",
                        icon: "el-icon-check",
                        type: "success"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.tagsPanelVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.tagsPanelVisible = $event)),
      direction: "rtl",
      size: "40%",
      title: "打标签"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_tag_editor, {
          card: _ctx.selectedCard,
          "original-image-tags": _ctx.originalImageTags,
          "primary-tag-name": _ctx.cardKeyword?.keyword
        }, null, 8, ["card", "original-image-tags", "primary-tag-name"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})